// Copyright (c) 2022 by Move Closer

import { VideoDriver } from '../../Video.config'
import { HTMLVideo } from './index'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const isValidHTMlVideoSrc = (source: string):boolean => {
  return RegExp('^.*\\.(mp4|ogg|mpeg)').test(source)
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const htmlVideoDriver: VideoDriver = {
  checkForUse (source: string): boolean {
    return isValidHTMlVideoSrc(source)
  },

  component: HTMLVideo
}
